import { render } from "./tj-channel.vue?vue&type=template&id=4bd6cc18&scoped=true"
import script from "./tj-channel.vue?vue&type=script&lang=js"
export * from "./tj-channel.vue?vue&type=script&lang=js"

import "./tj-channel.vue?vue&type=style&index=0&id=4bd6cc18&scoped=true&lang=css"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd6cc18"]])

export default __exports__